// import clsx from "clsx";
import { graphql, StaticQuery } from "gatsby";
import PropTypes from "prop-types";
import React from "react";
// import Img from "gatsby-image";
import BlogArticle from "../components/BlogArticle";
import { Button } from "gatsby-theme-material-ui";
// import { SubdirectoryArrowLeft as SubdirectoryArrowLeftIcon } from "mdi-material-ui";
import { createStyles, makeStyles } from "@material-ui/core/styles";

// import PreviewCompatibleImage from "./PreviewCompatibleImage";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: "grid",
      [theme.breakpoints.down("sm")]: {
        rowGap: `${theme.spacing(8)}px`
      },
      [theme.breakpoints.up("sm")]: {
        rowGap: `${theme.spacing(16)}px`
      }
    },
    footer: {
      marginTop: theme.spacing(4),
      textAlign: "center",
      [theme.breakpoints.up("sm")]: {
        paddingLeft: "30%"
      }
    }
    // article: {
    //   display: "grid",
    //   gap: `${theme.spacing(1)}px`,
    //   gridAutoFlow: "1fr auto 1fr",
    //   "&.featured": {}
    // }
  })
);

const BlogRoll = ({
  data
}: InferProps<typeof FeatureGrid.propTypes>): ReactElement => {
  const classes = useStyles();

  const { edges: posts } = data.allMarkdownRemark;

  return (
    <div className={classes.root}>
      {posts &&
        posts.map(({ node: post }, index) => (
          <div key={index}>
            <BlogArticle
              content={post.html}
              // content={post.excerpt}
              // contentComponent={HTMLContent}
              // description={description}
              featuredimage={post.frontmatter.featuredimage}
              imagewidth={post.frontmatter.imagewidth}
              tags={post.frontmatter.tags}
              title={post.frontmatter.title}
              subheading={post.frontmatter.subheading}
              date={post.frontmatter.date}
              preview={true}
            />
            <footer className={classes.footer}>
              <Button
                variant="contained"
                color="default"
                className={classes.button}
                // startIcon={<SubdirectoryArrowLeftIcon />}
                to={post.fields.slug}
              >
                View post
              </Button>
            </footer>
          </div>
        ))}
    </div>
  );
};

BlogRoll.propTypes = {
  data: PropTypes.shape({
    allMarkdownRemark: PropTypes.shape({
      edges: PropTypes.array
    })
  })
};

export const BlogRollStaticQuery = (): ReactElement => (
  <StaticQuery
    query={graphql`
      query BlogRollQuery {
        allMarkdownRemark(
          sort: { order: DESC, fields: [frontmatter___date] }
          filter: { frontmatter: { templateKey: { eq: "blog-post" } } }
          limit: 40
        ) {
          edges {
            node {
              # excerpt(pruneLength: 200)
              # excerpt(format: HTML)
              html
              id
              fields {
                slug
              }
              frontmatter {
                date
                featuredimage {
                  childImageSharp {
                    fluid(maxWidth: 640, maxHeight: 480, quality: 64) {
                      ...GatsbyImageSharpFluid
                    }
                  }
                }
                imagewidth
                id
                summary
                templateKey
                title
                subheading
              }
            }
          }
        }
      }
    `}
    render={(data, index): ReactElement => (
      <BlogRoll data={data} count={index} />
    )}
  />
);

export default BlogRollStaticQuery;
